module.exports = __webpack_public_path__ + "img/av129.6dfa9dd6.png";